/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
// import ErrorIcon from './ErrorIcon';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log('error: ', error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('errorInfo: ', errorInfo);
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: 1,
            textAlign: 'center',
            mt: 30,
            '& svg': {
              width: '100%',
              maxWidth: 400,
              color: (theme) => theme.palette.primary.main,
            },
          }}
        >
          {/* <ErrorIcon /> */}
          <Typography
            variant="h2"
            component="h2"
            style={{ fontSize: 30, marginTop: 16 }}
          >
            Pardon! Birşeyler yanlış gitti.
          </Typography>
          <Typography style={{ fontSize: 18, marginTop: 12 }}>
            Gözümüzden kaçan bir hatayı buldunuz. Merak etmeyin gerekli notları alıyoruz.
          </Typography>
          <Typography style={{ fontSize: 18 }}>
            Sayfayı yenileyebilir ya da daha sonra tekrar deneyebilirsiniz.
          </Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
